import React, { useEffect } from 'react';
import { useField, useForm } from 'react-final-form';

import { TEMPORARY_FORM_FIELDS } from '../../../scene/integrations/types';
import { notPresent } from '../../../utils/validations/required';

export type ConflictedRolesFieldProps = {
  conflictedRoles: Record<string, string[]>;
};

export const ConflictedRolesField: React.FC<ConflictedRolesFieldProps> = ({ conflictedRoles }) => {
  const { change } = useForm();

  useField<Record<string, string[]> | undefined>(TEMPORARY_FORM_FIELDS.conflictedRoles, {
    validate: notPresent,
    initialValue: conflictedRoles,
    subscription: {},
  });

  useEffect(
    () => change(TEMPORARY_FORM_FIELDS.conflictedRoles, conflictedRoles),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [conflictedRoles]
  );

  // do not render, this component is just for correct registering of field inside RFF
  return null;
};
